import { useEffect, useState } from "react";
import { isEmpty } from "lodash";
import { useDispatch, useSelector } from "react-redux";
import {
  getGeolocationStatus,
  getGeolocationError,
  getGeolocationErrorRetryable
} from "@tvg/sh-geolocation/src/redux/selectors";
import { GeolocationStatus } from "@tvg/sh-geolocation/src/types";
import { getGeoTokenCookie } from "@tvg/sh-utils/sessionUtils";
import { getIsLogged } from "@urp/store-selectors";
import { tryGeolocationRetry } from "@tvg/sh-geolocation/src/redux/actions";
import { isFdr } from "../utils/general";

type UseGeocomplyBetDisabled = {
  isBetDisabled: boolean;
  isGeolocationErrorRetryable: boolean | undefined;
  isGeolocationError: boolean;
};

export const useGeocomplyBetDisabled = (): UseGeocomplyBetDisabled => {
  const dispatch = useDispatch();
  const [isBetDisabled, setIsBetDisabled] = useState<boolean>(false);
  const geolocationStatus = useSelector(getGeolocationStatus);
  const geolocationError = useSelector(getGeolocationError);
  const isGeolocationErrorRetryable: boolean | undefined = useSelector(
    getGeolocationErrorRetryable
  );
  const isLogged = useSelector(getIsLogged);

  useEffect(() => {
    if (isFdr()) {
      const isGeolocationError =
        !isEmpty(geolocationError) ||
        geolocationStatus === GeolocationStatus.REJECTED ||
        geolocationStatus === GeolocationStatus.FAILURE;
      const isGeolocationRunningUpdate =
        geolocationStatus === GeolocationStatus.PROGRESS;

      // prevent token disappear for unknow reason (without errors)
      if (
        isLogged &&
        !getGeoTokenCookie() &&
        !isGeolocationError &&
        !isGeolocationRunningUpdate
      ) {
        dispatch(tryGeolocationRetry(true));
      }

      setIsBetDisabled(
        !isLogged ||
          isGeolocationError ||
          !isGeolocationErrorRetryable ||
          isGeolocationRunningUpdate
      );
    }
  }, [
    geolocationStatus,
    geolocationError,
    isGeolocationErrorRetryable,
    isLogged
  ]);

  return {
    isBetDisabled,
    isGeolocationErrorRetryable,
    isGeolocationError: isLogged && !isEmpty(geolocationError)
  };
};

export default useGeocomplyBetDisabled;
